import { render, staticRenderFns } from "./SubTaskContextMenu.vue?vue&type=template&id=482167f3&"
import script from "./SubTaskContextMenu.vue?vue&type=script&lang=js&"
export * from "./SubTaskContextMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('482167f3')) {
      api.createRecord('482167f3', component.options)
    } else {
      api.reload('482167f3', component.options)
    }
    module.hot.accept("./SubTaskContextMenu.vue?vue&type=template&id=482167f3&", function () {
      api.rerender('482167f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Task/SubTaskContextMenu.vue"
export default component.exports